import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface DocumentsList {
  id: number;
  name: string;
  description: string;
  documents: number[];
}

export const useDocumentsLists = () => {
  return useQuery({
    queryKey: ["documentsLists"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("documents_lists")
        .select("*")
        .order("name");

      if (error) {
        console.error("Error fetching documents lists:", error);
        throw error;
      }
      return (data as DocumentsList[]) || [];
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30 // 30 minutes
  });
};
